import React, { useId, useState } from "react";
import { ChevronDown } from "lucide-react";
import "./ParamGroup.css";

function ParamGroup({ title, children, defaultOpen = true, collapsible = true }) {
    const [open, setOpen] = useState(defaultOpen);
    const id = useId();
    const isOpen = collapsible ? open : true;

    return (
        <section className="param-group">
            <button
                type="button"
                className="param-group__header focus-ring"
                aria-expanded={isOpen}
                aria-controls={`pg-${id}`}
                onClick={() => collapsible && setOpen((o) => !o)}
                disabled={!collapsible}
            >
                <span className="param-group__title">{title}</span>
                {collapsible && (
                    <ChevronDown
                        size={14}
                        className={`param-group__chev ${isOpen ? "param-group__chev--open" : ""}`}
                        aria-hidden="true"
                    />
                )}
            </button>
            {isOpen && (
                <div className="param-group__body" id={`pg-${id}`}>
                    {children}
                </div>
            )}
        </section>
    );
}

export default ParamGroup;
